var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99999 13.3333C6.5111 13.3333 5.24999 12.8167 4.21666 11.7833C3.18332 10.75 2.66666 9.48888 2.66666 7.99999C2.66666 6.5111 3.18332 5.24999 4.21666 4.21666C5.24999 3.18332 6.5111 2.66666 7.99999 2.66666C8.76666 2.66666 9.49999 2.82488 10.2 3.14132C10.9 3.45777 11.5 3.91066 12 4.49999V2.66666H13.3333V7.33332H8.66666V5.99999H11.4667C11.1111 5.37777 10.6251 4.88888 10.0087 4.53332C9.39221 4.17777 8.72266 3.99999 7.99999 3.99999C6.88888 3.99999 5.94443 4.38888 5.16666 5.16666C4.38888 5.94443 3.99999 6.88888 3.99999 7.99999C3.99999 9.1111 4.38888 10.0555 5.16666 10.8333C5.94443 11.6111 6.88888 12 7.99999 12C8.85555 12 9.62777 11.7555 10.3167 11.2667C11.0055 10.7778 11.4889 10.1333 11.7667 9.33332H13.1667C12.8555 10.5111 12.2222 11.4722 11.2667 12.2167C10.3111 12.9611 9.22221 13.3333 7.99999 13.3333Z",
    fill: "#433E48"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRefresh);
export default __webpack_public_path__ + "static/media/location_refresh.a1c599a5c8d4fff20b967decf335be0c.svg";
export { ForwardRef as ReactComponent };